import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';

import { BaseComponent } from '../../../shared/abstracts/base.abstract';
import { IBug } from '../../../shared/interfaces';
import { BugSupportService } from '../../../shared/services';
import { IUser } from './../../../shared/interfaces/users/user.interface';
import { ModalService } from './../../../shared/services/internal/modal.service';

@Component({
    selector: 'app-support-form',
    templateUrl: './support-form.component.html',
    styleUrls: ['./support-form.component.scss'],
})
export class SupportFormComponent extends BaseComponent implements OnInit {
    @Input()
    public user: IUser;

    public supportForm: FormGroup;

    constructor(
        private router: Router,
        private fb: FormBuilder,
        private device: DeviceDetectorService,
        private bugService: BugSupportService,
        private modalService: ModalService
    ) {
        super();
    }

    ngOnInit(): void {
        this.supportForm = this.fb.group({
            bug_description: [''],
            normal_behavior: [''],
        });
    }

    public onSubmitSupportForm(): void {
        const deviceInfos: string =
            'Role: ' +
            this.user.role[0].name +
            '\r\n' +
            'Browser: ' +
            this.device.browser +
            '\r\n' +
            'Browser version: ' +
            this.device.browser_version +
            '\r\n' +
            'Device: ' +
            this.device.device +
            '\r\n' +
            'Device Type: ' +
            this.device.deviceType +
            '\r\n' +
            'Orientation: ' +
            this.device.orientation +
            '\r\n' +
            'Operating system: ' +
            this.device.os +
            '\r\n' +
            'OS version: ' +
            this.device.os_version;

        const report: IBug = {
            ...this.supportForm.value,
            navigator: deviceInfos,
            active_url: window.origin + this.router.url,
        };

        this.bugService.postBugReport(report).subscribe(() => {
            this.modalService.closeModal();
        });
    }
}
